import { DestroyRef, Directive, ElementRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { filter, fromEvent, merge, Observable } from "rxjs";

@Directive({
    selector: '[libStopPropagation]',
    standalone: true,
})
export class StopClickPropagationDirective implements OnInit {

    /**
     * When true, event propagation will be prevented when the user clicks the element
     *
     * Values provided will be coerced into a boolean {@link coerceBooleanProperty}
     *
     * Default is true e.g. libStopPropagation
     */
    @Input({ alias: 'libStopPropagation', transform: coerceBooleanProperty })
    public shouldStopPropagation: boolean = true;

    @Input({ transform: coerceBooleanProperty })
    public stopContextMenu: boolean = false;

    private readonly _elRef: ElementRef = inject(ElementRef);

    private readonly _destroyRef: DestroyRef = inject(DestroyRef);

    public ngOnInit(): void {
        const eventsList: Observable<MouseEvent>[] = [
            fromEvent<MouseEvent>(this._elRef.nativeElement, 'click')
                .pipe(
                    filter(() => this.shouldStopPropagation)
                ),
            fromEvent<MouseEvent>(this._elRef.nativeElement, 'contextmenu')
                .pipe(
                    filter(() => this.stopContextMenu)
                ),
        ];

        merge(...eventsList)
            .pipe(
                takeUntilDestroyed(this._destroyRef)
            )
            .subscribe((event: MouseEvent) => {
                event.stopPropagation();
            });
    }
}